import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMG } from "@/lib/api";

const spot = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

const Card = ({ className = "", children, i, testid }) => (
  <motion.div onMouseMove={spot} data-testid={testid}
    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className={`spot-card relative min-h-[300px] overflow-hidden border border-white/10 p-7 transition-colors duration-500 hover:border-white/25 sm:p-9 ${className}`}>
    {children}
  </motion.div>
);

const SLOTS = ["8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM"];

export const Bento = () => (
  <section id="why" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32" data-testid="bento-section">
    <div className="mb-14 flex items-end justify-between gap-6">
      <h2 className="font-display text-5xl uppercase leading-[0.9] text-zinc-50 sm:text-7xl lg:text-8xl">Why <span className="font-serif-i normal-case text-acid">us?</span></h2>
      <p className="eyebrow hidden sm:block">( Four reasons. No filler. )</p>
    </div>
    <div className="grid auto-rows-[minmax(300px,auto)] grid-cols-1 gap-4 md:grid-cols-12">
      <Card i={0} className="md:col-span-8" testid="bento-card-obsessive">
        <p className="eyebrow">01 / Standard</p>
        <p className="mt-6 font-display text-5xl uppercase leading-[0.9] text-zinc-50 sm:text-7xl">Every. Damn.<br />Corner.</p>
        <p className="mt-6 max-w-md text-zinc-400">Baseboards, grout lines, the top of the fridge nobody checks. We check. Obsessive isn&apos;t a phase, it&apos;s the policy.</p>
      </Card>
      <Card i={1} className="p-0 sm:p-0 md:col-span-4" testid="bento-card-detail">
        <img src={IMG.faucet} alt="Polished fixture detail" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-[1.2s] hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
        <div className="absolute bottom-7 left-7 right-7">
          <p className="eyebrow text-zinc-300">02 / Detail</p>
          <p className="mt-3 font-serif-i text-3xl text-zinc-50">Detail is the whole point.</p>
        </div>
      </Card>
      <Card i={2} className="md:col-span-4" testid="bento-card-range">
        <p className="eyebrow">03 / Range</p>
        <p className="mt-6 font-display text-6xl uppercase leading-[0.9] text-zinc-50">Homes <span className="font-serif-i normal-case text-acid">&amp;</span><br />HQs.</p>
        <p className="mt-6 text-zinc-400">From a one-bedroom to a whole office floor. Same standard. Same attitude.</p>
      </Card>
      <Card i={3} className="flex flex-col justify-between gap-8 md:col-span-8 md:flex-row md:items-end" testid="bento-card-booking">
        <div>
          <p className="eyebrow">04 / Booking</p>
          <p className="mt-6 font-display text-5xl uppercase leading-[0.9] text-zinc-50 sm:text-6xl">Booked in<br />under a minute.</p>
          <p className="mt-6 max-w-sm text-zinc-400">Pick a service. Pick a date. Pick a slot. Done. No phone tag, no &ldquo;we&apos;ll get back to you.&rdquo;</p>
        </div>
        <div className="flex flex-col gap-3 md:w-64">
          <div className="grid grid-cols-2 gap-2">
            {SLOTS.map((s, i) => (
              <span key={s} className={`rounded-full border px-3 py-2 text-center font-mono-x text-xs ${i === 1 ? "border-[var(--acid)] bg-acid text-black" : "border-white/15 text-zinc-300"}`}>{s}</span>
            ))}
          </div>
          <Link to="/book" data-testid="bento-book-button" className="group flex items-center justify-between rounded-full bg-zinc-100 px-5 py-3 font-bold text-black transition-colors duration-300 hover:bg-acid">
            Grab a slot <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
        </div>
      </Card>
    </div>
  </section>
);
